import { HttpErrorResponse } from '@angular/common/http';

/**
 * The text to show a user for a failed API call.
 *
 * ⚠️ The callers used to do `error.error.split('!')` directly. That assumes the body is a
 * STRING, which it only is when the API returned a plain BadRequest. Anything else - an
 * unhandled 500 (a ProblemDetails object), a gateway HTML page, a dropped connection (null) -
 * makes `.split` throw INSIDE the error handler. The modal has already been opened and had its
 * header set by then, so the failure shows as an empty dialog with an Ok button: the one thing
 * that tells you what went wrong is the thing that gets swallowed.
 *
 * The '!' split is how the API separates several messages into lines; that behaviour is kept.
 */
export function apiErrorMessage(error: HttpErrorResponse, fallback: string): string {
  const body = error?.error;

  if (typeof body === 'string' && body.trim().length > 0) {
    return body.split('!').join('<br/>');
  }

  // ProblemDetails and friends: take whichever field carries something readable.
  if (body && typeof body === 'object') {
    const detail = (body as Record<string, unknown>)['detail'] ?? (body as Record<string, unknown>)['title'];
    if (typeof detail === 'string' && detail.trim().length > 0) {
      return detail;
    }
  }

  // Nothing usable in the body - say what the status was rather than showing an empty box.
  return error?.status ? `${fallback} (${error.status} ${error.statusText ?? ''})`.trim() : fallback;
}
